import { Button, Tooltip, Typography } from '@mui/material'
import { useSessionContex } from '../SessionContex'
import AgentChatLogo from '../common-images/app-logo/agent-chat-logo'
import { getColor, getLightColor } from '../lib/utils'
import { getColorCode } from '../utils/helper'

const FloatingChatButton = () => {
  const { setCollapsed, collapsed } = useSessionContex()
  return (
    <Tooltip
      disableInteractive
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: '#707e8c'
          }
        }
      }}
      title={<Typography>Smart Agent</Typography>}
    >
      <Button
        className={`chat_btn${
          process.env.REACT_APP_COLOR === 'hitron'
            ? '_hitron'
            : process.env.REACT_APP_COLOR === 'customer'
            ? '_customer'
            : process.env.REACT_APP_COLOR === 'entpnt'
            ? '_entpnt'
            : '_scaling'
        } !rounded-full`}
        onClick={() => setCollapsed(false)}
        style={{
          color:
            process.env.REACT_APP_REALM === 'Scalingtests'
              ? getLightColor()
              : process.env.REACT_APP_REALM === 'Customer'
              ? getColor()
              : getColorCode(process.env.REACT_APP_COLOR === 'entpnt' ? 'purpleBlue' : 'redToBlue'),
          border: `2px solid ${
            process.env.REACT_APP_REALM === 'Scalingtests'
              ? getLightColor()
              : process.env.REACT_APP_REALM === 'Customer'
              ? getColor()
              : getColorCode(process.env.REACT_APP_COLOR === 'entpnt' ? 'purpleBlue' : 'redToBlue')
          }`,
          cursor: 'pointer'
        }}
        data-testid='testid_smart_agent_chat_btn'
        disabled={!collapsed}
      >
        <AgentChatLogo />
      </Button>
    </Tooltip>
  )
}

export default FloatingChatButton
